import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './AkademisyenTanimla.css';
import { API_ENDPOINTS } from '../config/api';

const AkademisyenTanimla = () => {
  const { t } = useTranslation();
  const [educationTypes, setEducationTypes] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [courses, setCourses] = useState([]);

  const [selectedEducationTypes, setSelectedEducationTypes] = useState([]);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [title, setTitle] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // Akademisyen ünvanları
  const titles = [
    'Dr. Öğr. Üyesi',
    'Öğr.Gör.',
    'Prof.Dr.',
    'Araş.Gör.',
    'Doç.Dr.',
    'Öğr.Gör.Dr.'
  ];

  useEffect(() => {
    axios.get(API_ENDPOINTS.EDUCATION_TYPES).then(res => setEducationTypes(res.data));
  }, []);

  useEffect(() => {
    if (selectedEducationTypes.length > 0) {
      Promise.all(selectedEducationTypes.map(id => axios.get(`${API_ENDPOINTS.FACULTIES}?educationTypeId=${id}`)))
        .then(responses => setFaculties(responses.flatMap(r => r.data)));
    } else {
      setFaculties([]);
    }
    setSelectedFaculties([]);
    setPrograms([]);
    setCourses([]);
  }, [selectedEducationTypes]);

  useEffect(() => {
    if (selectedFaculties.length > 0) {
      Promise.all(selectedFaculties.map(id => axios.get(`${API_ENDPOINTS.PROGRAMS}?facultyId=${id}`)))
        .then(responses => setPrograms(responses.flatMap(r => r.data)));
    } else {
      setPrograms([]);
    }
    setSelectedPrograms([]);
    setCourses([]);
  }, [selectedFaculties]);

  useEffect(() => {
    if (selectedPrograms.length > 0) {
      Promise.all(selectedPrograms.map(id => axios.get(`${API_ENDPOINTS.COURSES}?programId=${id}`)))
        .then(responses => setCourses(responses.flatMap(r => r.data)));
    } else {
      setCourses([]);
    }
    setSelectedCourses([]);
  }, [selectedPrograms]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const res = await axios.post(API_ENDPOINTS.AKADEMISYEN_REGISTER, {
        email,
        password,
        title,
        education_types: selectedEducationTypes,
        faculties: selectedFaculties,
        programs: selectedPrograms,
        courses: selectedCourses
      });
      if (res.data.success) {
        setSuccess(t('akademisyen.addedSuccess'));
        setEmail('');
        setPassword('');
        setTitle('');
        setSelectedEducationTypes([]);
        setSelectedFaculties([]);
        setSelectedPrograms([]);
        setSelectedCourses([]);
      } else {
        setError(res.data.error || t('akademisyen.saveFailed'));
      }
    } catch (err) {
      setError(err.response?.data?.error || t('akademisyen.saveError'));
    }
  };

  return (
    <div className="akademisyen-tanimla-container">
      <h2>{t('akademisyen.define')}</h2>

      {success && <div className="akademisyen-success">{success}</div>}
      {error && <div className="akademisyen-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="akademisyen-form-grid">
          <div className="akademisyen-form-field">
            <label>{t('akademisyen.email')}</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder={t('akademisyen.emailPlaceholder')}
            />
          </div>
          <div className="akademisyen-form-field">
            <label>{t('akademisyen.password')}</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder={t('akademisyen.passwordPlaceholder')}
            />
          </div>
        </div>

        <div className="akademisyen-form-field">
          <label>{t('akademisyen.titleLabel')}</label>
          <select value={title} onChange={e => setTitle(e.target.value)} required>
            <option value="">{t('akademisyen.titlePlaceholder')}</option>
            {titles.map((titleOption, index) => (
              <option key={index} value={titleOption}>{titleOption}</option>
            ))}
          </select>
        </div>

        <div className="akademisyen-form-field">
          <label>{t('akademisyen.educationTypes')}</label>
          <select
            multiple
            value={selectedEducationTypes}
            onChange={e => setSelectedEducationTypes(Array.from(e.target.selectedOptions, o => o.value))}
          >
            {educationTypes.map(et => <option key={et.id} value={et.id}>{et.name}</option>)}
          </select>
        </div>

        <div className="akademisyen-form-field">
          <label>{t('akademisyen.faculties')}</label>
          <select
            multiple
            value={selectedFaculties}
            onChange={e => setSelectedFaculties(Array.from(e.target.selectedOptions, o => o.value))}
          >
            {faculties.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
          </select>
        </div>

        <div className="akademisyen-form-field">
          <label>{t('akademisyen.programs')}</label>
          <select
            multiple
            value={selectedPrograms}
            onChange={e => setSelectedPrograms(Array.from(e.target.selectedOptions, o => o.value))}
          >
            {programs.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>

        <div className="akademisyen-form-field">
          <label>{t('akademisyen.courses')}</label>
          <select
            multiple
            value={selectedCourses}
            onChange={e => setSelectedCourses(Array.from(e.target.selectedOptions, o => o.value))}
          >
            {courses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>

        <button type="submit" className="akademisyen-submit-btn">
          {t('akademisyen.save')}
        </button>
      </form>
    </div>
  );
};

export default AkademisyenTanimla; 